<template>
    <div class="page-car">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :span="18" v-if="$zonesDict">
                    <h2 class="m-b-0">{{ ($zonesDict.find(x => x.ID === zoneId) ? $zonesDict.find(x => x.ID === zoneId).Name : "Зона №" + zoneId)}}</h2>
                </el-col>
                <el-col :span="6" align="right" class="d-flex">

                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="24" :xl="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="name" label="">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                {{ scope.row.View.DisplayName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="value" label="">
                        <template slot-scope="scope">
                            <Input2 :itemType="itemType" :value="scope.row.Value" :view="scope.row.View" />
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Input2 from '@/components/Input2'

    export default {
        components: { Input2 },
        data () {
            return {
                itemType: 'Zone',
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    Search: '',
                    Page: 1,
                    PageSize: 20
                },
                loading: false,
                total: 0,
                dataTable: [],
                zoneId: this.$route.params.id
            }
        },
        created () {
            this.getData()
        },
        methods: {
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemView",
                    ItemType: "Zone",
                    OperatorName: "Admin",
                    ItemId: this.zoneId
                }, this.form)

                this.$api.Main.getZones(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Parameters
                }).catch (() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
